import React from 'react'
import { useLocation } from 'react-router-dom'
import Header from './include/Header'
import Footer from './include/Footer'

function Base({ children }) {
    const location = useLocation();
    
    // List of khata pages where header should be hidden
    const khataPages = [
        '/receivable-khata',
        '/payable-khata',
        '/bank-khata',
        '/expense-ledger',
        '/expense-fields-ledger',
        '/expense-fields-details',
        '/profit-loss-account'
    ];
    
    // Check if current path is a khata page
    const isKhataPage = khataPages.some(path => location.pathname.startsWith(path));

    return (
        <>
            {!isKhataPage && <Header />}
            {children}
            {!isKhataPage && <Footer />}
        </>
    )
}

export default Base